// @ts-nocheck
import {
    chain,
    DispatchSetProductFilters,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { addToChainBefore } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainBefore(chain, DispatchSetProductFilters, props => {
    if (props.parameter.excludeMultiLocationCatalogProducts !== undefined) {
        props.result.excludeMultiLocationCatalogProducts = undefined;
    }
    if (props.parameter.onlyGreifProducts !== undefined) {
        props.result.onlyGreifProducts = undefined;
    }
    /* Store Custom Code - Start */
    if ("query" in props.parameter) {
        props.result.query = undefined;
        props.result.includeSuggestions = undefined;
        props.result.page = undefined;
    }
    /* Store Custom Code - End */
});
